import React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';

type Props = { text: string };

function Label(props: Props & LabelPrimitive.LabelProps) {
  const { text, ...rest } = props;

  return (
    <LabelPrimitive.Root className='label' asChild {...rest}>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label>{text}</label>
    </LabelPrimitive.Root>
  );
}

export default Label;
